/**
 * RBSheet Shim/Stub Module
 * 
 * This module exports the correct RBSheet implementation based on the platform:
 * - Web: Uses custom Modal-based implementation (RBSheetWeb)
 * - Native: Uses the actual react-native-raw-bottom-sheet library
 */

import { Platform } from 'react-native';

let RBSheet: any;

if (Platform.OS === 'web') {
  // Use custom web implementation
  RBSheet = require('../components/RBSheetWeb/RBSheetWeb').default;
} else {
  // Use native RBSheet
  RBSheet = require('react-native-raw-bottom-sheet').default;
}

export default RBSheet;
